import React, { useRef, useEffect } from 'react';
import './ImageWithText.css';
import CloudAnimation from './CloudAnimation';
import useFadeOnScroll from './UseFadeOnScroll';

const ImageWithText = () => {
  const divRef = useRef(null);
  let dynamicThreshold = window.innerWidth <= 768 ? 0.1 : 0.5;
  const { addElementRef, removeElementRef } = useFadeOnScroll({ threshold: dynamicThreshold });

  useEffect(() => {
    addElementRef(divRef);
    return () => removeElementRef(divRef);
  }, [addElementRef, removeElementRef]);

  return (
    <div ref={divRef} className="container">
      <div className="image-container">
        <CloudAnimation />
      </div>
      <div className="text-container">
        <h1 className="bio-header">
          Enabling bioinformatics in the cloud
        </h1>
        <p>
          royston.io is a consultancy that enables bioinformatics in the cloud.
          Our team has over a decade's worth of experience writing bioinformatics code and
          building cloud infrastructure to the highest standards.
        </p>
        <h2>We can help with...</h2>
        <ul>
          <li>Bioinformatics software development</li>
          <li>Bioinformatics cloud compute infrastructure</li>
          <li>Data management and strategy</li>
          <li>Bioinformatics research and analysis</li>
          <li>Research and software project management</li>
          <li>Biotech specific cyber security</li>
        </ul>
      </div>
    </div>
  );
};

export default ImageWithText;